import { classNames } from 'primereact/utils'
import { InputSwitchPassThroughOptions } from 'primereact/inputswitch'

export const inputSwitchConfig: InputSwitchPassThroughOptions = {
  root: (options) => ({
    className: classNames({ 'mk-switch--disabled': options?.props?.disabled }),
  }),
  input: {
    className: 'mk-switch__input',
  },
  slider: (options) => {
    const { props } = options || {}
    return {
      className: classNames('mk-switch__slider', {
        'mk-switch__slider--off': !props?.checked,
        'mk-switch__slider--on': props?.checked,
      }),
    }
  },
}
